var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GameResult"},[_c('h2',[_vm._v(" Totalpoäng: ")]),(_vm.getPlayer)?_c('UserScore',{attrs:{"user":_vm.getPlayer}}):_vm._e(),_c('br'),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }